import { Failure } from 'query/Fetch';
import React from 'react';
import './DataTable.css';

export interface FetchErrorProps {
    error: Failure;
}

export interface FetchErrorState {

}

export class FetchError extends React.Component<FetchErrorProps, FetchErrorState> {
    constructor(props: Readonly<FetchErrorProps>) {
        super(props);
        this.state = {
        };
    }

    render = () => {
        const er = this.props.error;

        return <div style={{position:'absolute', margin:'1em', width:'80ex', color:'black',backgroundColor:'white'}}>
            <h3>Error occurred</h3>
            { er.url && <div>
                <p>While fetching:</p>
                <p>Direct link: <a href={er.url}>{decodeURIComponent(er.url)}</a></p>
                <p><a href={er.proxiedUrl}>Proxied Link</a></p>
            </div> }
            <h4>{er.message}</h4>
            <p style={{fontFamily: 'monospace', overflowWrap: 'anywhere'}}>{er.details}</p>
        </div>
    }
}
